<template>
  <div id="app">
    <div class="fix-btn">
      <div class="flex-row call">
        <img src="@/assets/images/common/call.png" alt="" />
      </div>
      <div class="service-number flex-row">
        <img src="@/assets/images/common/phone.png" alt="" />&emsp;400-820-3779
      </div>
      <div
        :style="
          showBtn
            ? 'opacity:1;visibility:visible'
            : 'opacity:0;visibility:hidden'
        "
        @click="backTop"
        class="flex-row back-top"
      >
        <img src="@/assets/images/common/back-top.png" alt="" />
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      showBtn: false
    };
  },
  mounted() {
    window.addEventListener("scroll", this.showbtn, true);
  },
  methods: {
    backTop() {
      var timer = setInterval(function() {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 3);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        this.isTop = true;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    },
    showbtn() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.scrollTop = scrollTop;
      if (scrollTop > 900) {
        this.showBtn = true;
      } else {
        this.showBtn = false;
      }
    }
  }
};
</script>

<style>
* {
  box-sizing: border-box;
  list-style: none;
}
#app {
  width: 100%;
  margin: 0 auto;
  font-family: "Helvetica Neue", PingFangSC-regular, "Hiragino Sans GB",
    "Microsoft YaHei", "WenQuanYi Micro Hei", " sans-serif";
}
html,
body,
p,
h1,
h3,
ul,
li {
  margin: 0;
  padding: 0;
}
.BMap_cpyCtrl {
  display: none;
}
.anchorBL {
  display: none;
}
.flex-row {
  display: flex;
  flex-direction: row;
}
.flex-col {
  display: flex;
  flex-direction: column;
}
.container {
  width: 1200px;
  margin: 0 auto;
}
.white-title {
  font-size: 30px;
  color: #ffffff;
  text-align: center;
  font-weight: 600;
  display: inline-block;
  margin: 54px auto;
  position: relative;
}
.white-title::after {
  display: inline-block;
  content: "";
  position: absolute;
  bottom: -20px;
  left: 50%;
  transform: translateX(-50%);
  width: 120px;
  height: 4px;
  background: #fff;
}
.blue-title {
  font-size: 30px;
  color: #15659e;
  text-align: center;
  font-weight: 600;
  display: inline-block;
  margin: 54px auto;
  position: relative;
}
.blue-title::after {
  display: inline-block;
  content: "";
  position: absolute;
  bottom: -20px;
  left: 50%;
  transform: translateX(-50%);
  width: 120px;
  height: 4px;
  background: #15659e;
}
.fix-btn {
  position: fixed;
  right: 20px;
  bottom: 40px;
  z-index: 999;
}
.call,
.back-top {
  background: rgba(21, 101, 158, 0.5);
  width: 60px;
  height: 60px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-bottom: 1px;
  transition: 0.5s;
}
.call:hover,
.back-top:hover {
  background: #15659e;
}
.service-number {
  background: #15659e;
  color: #fff;
  width: 0;
  height: 60px;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 60px;
  top: 0;
}
.call:hover + .service-number {
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue